import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import Progress from 'components/Misc/Progress';
import { Title } from 'components/Misc/Typography';

import Exam from 'containers/Student/Courses/Profile/Exams/Exam';

const Exams = () => {
	// Cache current object's id
	const { id } = useParams();

	// Store request parameters
	const parameters = useMemo(() => ({
		joined: '[exam.subject]',
		courseId: id
	}), [id]);

	// Store requested takes
	const [[takes, progress], collect] = useCollect('takes', parameters);

	// Collect takes on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<div className="space-y-4">
			<div className="space-x-2 flex items-center">
				<Icon
					icon="assignment"
					className="text-2xl text-amber-500"
				/>
				
				<Title title="Pārbaudes darbi" />
			</div>

			{/* Show progress */}
			<Progress progress={progress} />

			{/* Show nothing if there are no exams */}
			<Show if={!progress && !takes?.length}>
				<div className="py-4 flex flex-col items-center space-y-2">
					<Icon
						icon="celebration"
						className="text-4xl text-neutral-400 dark:text-neutral-600"
					/>
				
					<div className="font-base text-neutral-400 dark:text-neutral-600">
						Modulim nav pārbaudes darbu!
					</div>
				</div>
			</Show>

			{/* Display course's takes */}
			<Show if={takes?.length}>
				<div className="space-y-2">
					{takes?.map(take =>
						<Exam key={take.id} take={take} />
					)}
				</div>
			</Show>
		</div>
	);
};

export default Exams;